import React, {useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
// import { FixedSizeList as List } from 'react-window';
import axios from 'axios'
import applyCaseMiddleware from 'axios-case-converter'
import { Button, IconButton, CircularProgress, Paper, TableContainer, Table, TableBody, TableCell, TableRow} from '@mui/material'
import { makeStyles, withStyles } from '@mui/styles'
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react'
import { updateClips, setBars, setBpm } from './editorSlice'
import { MAX_BARS, NUM_BEATS_PER_BAR, NUM_STEPS_PER_BEAT, PITCHES, NUMERALS, MAJOR_NUMERALS_PRESET, MAJOR_EXTRA_NUMERALS_PRESET, NUMERAL_TYPES, TYPE_TENSIONS} from './editorConstants'
import { getProgression, getProgressionJSX, getNumeralInMajor, checkFill, useKeyPressing, shuffleArray } from './editorUtils'
import StyledTypography from '../../components/StyledTypography'
import StyledTooltip from '../../components/StyledTooltip'
import {ReactComponent as GrooveLoopIcon} from './icons/groove-loop.svg'
import {ReactComponent as GrooveOneShotIcon} from './icons/groove-one-shot.svg'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import CasinoOutlinedIcon from '@mui/icons-material/CasinoOutlined';
import './Progression.css'

const LIBRARY_WIDTH = 630;
const ITEM_HEIGHT = 36;

const DenseTableCell = withStyles({
    root: {
        borderBottom: "none",
        color: 'white',
        display: 'flex',
        height: 24,
        textAlign: 'center'
    }
})(TableCell);

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: (LIBRARY_WIDTH - 6).toString() + '.px',
        overflow: 'visible',
        background: '#A0A0A0',
        boxSizing: 'content-box',
        border: 'none',
    },
    body: {
        '&:hover': {
            cursor: 'pointer'
        }
    },
    row: {
        height: '36px',
        '&:hover': {
            backgroundColor: '#757575'
            // boxShadow: '0px 2px 4px 0px rgb(74, 74, 74, 1.0)'
        }
    },
    container: {
        background: '#A0A0A0',
        borderWidth: 0,
        borderRadius: 0,
        overflow: 'visible',
    },
}));

export default function Progression(props) {
    const {height, progressionDropItem, showProgression, setShowProgression, wavesurfer, packId, showWarning} = props;
    const classes = useStyles();
    const containerHeight = height - 120;
    const listHeight = containerHeight - 16;
    const config = useSelector(state => state.editor.config);
    const clips = useSelector(state => state.editor.clips);
    const bars = useSelector(state => state.editor.bars);
    const key = useSelector(state => state.editor.key);
    const mode = useSelector(state => state.editor.mode);
    const bpm = useSelector(state => state.editor.bpm);
    const presetsProgressions = useSelector(state => state.editor.presetsProgressions);
    const myProgressions = useSelector(state => state.editor.myProgressions);
    const [hoveringRecommended, setHoveringRecommended] = useState(true);
    const [hoveringIndex, setHoveringIndex] = useState(-1);
    const [selectedRecommended, setSelectedRecommended] = useState(true);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [status, setStatus] = useState('editing');
    const [sessionId, setSessionId] = useState(-1);
    const [overFill, setOverFill] = useState(false);
    const [loadingProgression, setLoadingProgression] = useState(false);
    const dispatch = useDispatch();
    const currentProgression = getProgression(clips, bars);
    const upKeyPressing = useKeyPressing('ArrowUp', 38);
    const downKeyPressing = useKeyPressing('ArrowDown', 40);
    const spaceKeyPressing = useKeyPressing('Space', 32);
    let canFillCurrent = false;
    const dropGroup = progressionDropItem !== null && config.groups.find(group => group.id === progressionDropItem.id && group.type === progressionDropItem.type);
    const numChanges = progressionDropItem !== null ? Math.floor(MAX_BARS * NUM_BEATS_PER_BAR * dropGroup.changes.length / (progressionDropItem.beats === 0 ? 4 : progressionDropItem.beats)) : currentProgression.length;
    const [filteredPresetsProgressions, setFilteredPresetsProgressions] = useState([]);
    const [filteredMyProgressions, setFilteredMyProgressions] = useState([]);
    const presetsScrollBarRef = useRef();
    const myScrollBarRef = useRef();
    const selectedProgression = selectedIndex !== -1 && (selectedRecommended ? filteredPresetsProgressions[selectedIndex] : filteredMyProgressions[selectedIndex]);
    if (progressionDropItem !== null && currentProgression.length >= 2
        && currentProgression.length % dropGroup.changes.length === 0 && currentProgression.length / dropGroup.changes.length * (progressionDropItem.beats === 0 ? 1 : progressionDropItem.beats) <= MAX_BARS * NUM_BEATS_PER_BAR)
    {
        canFillCurrent = true;
        currentProgression.forEach(change => {
            const numeral_in_major = getNumeralInMajor(key, mode, change.root);
            const types =  !dropGroup.numeral ? dropGroup.types !== null ? dropGroup.types : ['']
            : (Object.keys(MAJOR_NUMERALS_PRESET).includes(numeral_in_major) ? MAJOR_NUMERALS_PRESET[numeral_in_major] : MAJOR_EXTRA_NUMERALS_PRESET[numeral_in_major]).filter(numeral => dropGroup.numerals.includes(numeral)).map(numeral => NUMERAL_TYPES[numeral]);
            if (!types.includes(change.type))
                canFillCurrent = false;
        });
    }
    const [currentClips, currentBars, currentBpm] = progressionDropItem === null ? (selectedIndex !== -1 ? utilizeProgession(selectedProgression) : [clips, bars, bpm]) : (selectedIndex !== -1 ? fillProgression(selectedProgression) : (canFillCurrent ? fillProgression(currentProgression) : [clips, bars, bpm]));

    useEffect(() => {
        return () => {
            if (sessionId !== -1)
                axios.post('/session/discard', {id: sessionId})
            setSessionId(-1);
            setStatus('editing');
            setHoveringIndex(-1);
            setSelectedIndex(-1);
        }
      }, [])
    
    useEffect(() => {
        if (showProgression)
            setTimeout(() => {
                setLoadingProgression(false);
                const index = filteredPresetsProgressions.findIndex(progression => JSON.stringify(progression) === JSON.stringify(currentProgression.map(change => {return {root: change.root, type: change.type}})))
                if (index !== -1)
                {
                    setSelectedIndex(index);
                    presetsScrollBarRef.current.osInstance().scroll({ y : index * ITEM_HEIGHT - containerHeight / 2});
                    setSelectedRecommended(true);
                }
            }, 300);
        else
            setTimeout(() => setLoadingProgression(true), 300);
        return () => setLoadingProgression(true);
    }, [showProgression])

    useEffect(() => {
    if (spaceKeyPressing && showProgression)
    {
        if (status === 'playing')
        {
            setStatus('editing');
            wavesurfer.stop();
        }
        else if (status === 'editing' && (progressionDropItem === null || selectedIndex !== - 1 || canFillCurrent))
            play(currentClips, currentBars, currentBpm);
    }
    }, [spaceKeyPressing]);
    
    useEffect(() => {
    if ((downKeyPressing || upKeyPressing) && status !== 'requesting' && showProgression)
    {
        const progressions = selectedRecommended ? filteredPresetsProgressions : filteredMyProgressions;
        const index = downKeyPressing && selectedIndex < progressions.length - 1 ? selectedIndex + 1 : (upKeyPressing && selectedIndex > 0 ? selectedIndex - 1 : -1);
        if (index === -1)
            return;
        const progression = progressions[index];
        play.apply(this, progressionDropItem !== null ? fillProgression(progression) : utilizeProgession(progression));
        const instance = (selectedRecommended ? presetsScrollBarRef : myScrollBarRef).current.osInstance();
        if (instance.scroll().position.y >= (selectedIndex - 1) * ITEM_HEIGHT)
            instance.scroll({y : (selectedIndex - 1 ) * ITEM_HEIGHT});
        else if (instance.scroll().position.y + listHeight <= (selectedIndex + 2) * ITEM_HEIGHT)
            instance.scroll({ y : (selectedIndex + 2 ) * ITEM_HEIGHT - listHeight});
        setSelectedIndex(index);
    }
    }, [downKeyPressing, upKeyPressing]);

    useEffect(() => {
        if (!showProgression && status === 'playing' && wavesurfer.backend !== null)
        {
            setStatus('editing');
            wavesurfer.stop();
        }
    }, [showProgression, status]);

    useEffect(() => {
        if (loadingProgression || showProgression)
        {
            setFilteredPresetsProgressions(filterProgressions(sortProgressions(presetsProgressions)));
            setFilteredMyProgressions(filterProgressions(sortProgressions(myProgressions)));
        }
    }, [loadingProgression, showProgression])

    function filterProgressions(progressions)
    {
        const filteredProgressions = [];
        for (const progression of progressions)
        {
            let matchedProgression = null;
            if (progression.length === numChanges)
                matchedProgression = progression;
            else if (progression.length * 2 === numChanges)
                matchedProgression = progression.concat(progression);
            else
            {
                const mergedProgression = [];
                for (const change of progression)
                {
                    if (mergedProgression.length === 0 || JSON.stringify(change) !== JSON.stringify(mergedProgression[mergedProgression.length - 1]))
                        mergedProgression.push(change);
                }
                if (mergedProgression.length === numChanges)
                    matchedProgression = mergedProgression;
            }
            if (matchedProgression !== null)
            {
                const convertedProgression = [];
                matchedProgression.forEach((change, changeIndex) => {
                    const group = progressionDropItem !== null ? dropGroup : config.groups.find(group => group.id === clips[currentProgression[changeIndex].clipIndex].id && group.type === clips[currentProgression[changeIndex].clipIndex].type);
                    const types =  !group.numeral ? group.types 
                    : (Object.keys(MAJOR_NUMERALS_PRESET).includes(change.numeral) ? MAJOR_NUMERALS_PRESET[change.numeral] : MAJOR_EXTRA_NUMERALS_PRESET[change.numeral]).filter(numeral => group.numerals.includes(numeral)).map(numeral => NUMERAL_TYPES[numeral]);
                    const type = group.types !== null ? types.includes(change.type) ? change.type : types.find(type => Object.keys(TYPE_TENSIONS).includes(type) && TYPE_TENSIONS[type].includes(change.type)) : '';
                    if (type !== undefined && type !== null)
                        convertedProgression.push({root: PITCHES[(PITCHES.indexOf(key) + (mode === 'major' ? 0 : 3) + NUMERALS.indexOf(change.numeral)) % PITCHES.length], type: type});
                });
                if (convertedProgression.length === matchedProgression.length && filteredProgressions.find(progression => JSON.stringify(progression) === JSON.stringify(convertedProgression)) === undefined)
                    filteredProgressions.push(convertedProgression);
            }
        }
        filteredProgressions.sort()
        return filteredProgressions;
    }
    
    function sortProgressions(progressions)
    {
        let sortedProgressions = [...progressions];
        if (mode === 'major')
        {
            sortedProgressions.sort();
            return sortedProgressions.map(progression => JSON.parse(progression).map(change => 
                {return {numeral: change.substr(0, change.indexOf(' ')), type: change.substr(change.indexOf(' ') + 1)}}));;
        }
        else
        {
            sortedProgressions = progressions.map(progression => JSON.stringify(JSON.parse(progression).map(change => change.replace('bVII', 'B').replace('VII', 'C').replace('VI', 'A'))));
            sortedProgressions.sort();
            sortedProgressions = sortedProgressions.map(progression => JSON.parse(progression).map(change => change.replace('B', 'bVII').replace('C', 'VII').replace('A', 'VI')));
            return sortedProgressions.map(progression => progression.map(change => 
                {return {numeral: change.substr(0, change.indexOf(' ')), type: change.substr(change.indexOf(' ') + 1)}}));;
            
        }
        
    }

    function utilizeProgession(progression)
    {
        const newClips = [];
        for (const clip of clips)
        {
            const newClip = {...clip, changes: []};
            for (const change of clip.changes)
                newClip.changes.push({...change})
            newClips.push(newClip);
        }
        progression.forEach((change, changeIndex) => {
            const newClip = newClips[currentProgression[changeIndex].clipIndex];
            const newChange = newClip.changes[currentProgression[changeIndex].changeIndex];
            newChange.root = change.root;
            if (newClip.numeral)
            {
                const numeral_in_major = getNumeralInMajor(key, mode, change.root);
                newChange.numeral = (Object.keys(MAJOR_NUMERALS_PRESET).includes(numeral_in_major) ? MAJOR_NUMERALS_PRESET[numeral_in_major] : MAJOR_EXTRA_NUMERALS_PRESET[numeral_in_major]).find(numeral => NUMERAL_TYPES[numeral] === change.type);
            }
            else
                newChange.type = change.type;
            checkFill(config, newClip, newChange, currentProgression[changeIndex].changeIndex, key, mode);
        });
        return [newClips, bars, bpm];
    }

    function fillProgression(progression)
    {
        const numClips = progression.length / dropGroup.changes.length;
        const beats = progressionDropItem.beats === 0 ? Math.pow(2, Math.floor(Math.log2(MAX_BARS * NUM_BEATS_PER_BAR / numClips))) : progressionDropItem.beats;
        const newClips = [];
        for (let i = 0; i < numClips; i++)
        {
            const clip = {
                id: progressionDropItem.id,
                name: progressionDropItem.name,
                type: progressionDropItem.type,
                beats: progressionDropItem.beats,
                sampleStart: 0,
                sampleEnd: beats * NUM_STEPS_PER_BEAT,
                loopStart: i * beats * NUM_STEPS_PER_BEAT,
                loopEnd: (i + 1) * beats * NUM_STEPS_PER_BEAT,
            };
            clip.numeral = dropGroup.numeral;
            clip.changes = dropGroup.changes.map((change, index) => ({
                start: (change.beat - 1) * NUM_STEPS_PER_BEAT + change.subdivision - 1,
                root: progression[i * dropGroup.changes.length + index].root,
                position: dropGroup.positions[Math.floor((dropGroup.positions.length - 1) / 2)],
                fill: null,
                gain: 0.0
            }));
            clip.changes.forEach((change, index) => {
                const type = progression[i * dropGroup.changes.length + index].type;
                if (clip.numeral)
                {
                    const numeral_in_major = getNumeralInMajor(key, mode, change.root);
                    change.numeral = (Object.keys(MAJOR_NUMERALS_PRESET).includes(numeral_in_major) ? MAJOR_NUMERALS_PRESET[numeral_in_major] : MAJOR_EXTRA_NUMERALS_PRESET[numeral_in_major]).find(numeral => NUMERAL_TYPES[numeral] === type);
                }
                else
                    change.type = type;
            });
            newClips.push(clip);
        }
        return [newClips, Math.round(newClips.length * beats / NUM_BEATS_PER_BAR), dropGroup.bpm === 0 ? 60 : dropGroup.bpm];
    }

    function ProgressionRow(progression, index, isRecommended) 
    {      
        const backgroundColor = (isRecommended === selectedRecommended && selectedIndex === index) ? '#FFB346' : (isRecommended === hoveringRecommended && hoveringIndex === index ? 'inherit' : (index % 2 === 0 ? '#888888' : '#A0A0A0'));

        return (
            <TableRow classes={{root: classes.row}} onMouseEnter={() => {setHoveringIndex(index); setHoveringRecommended(isRecommended)}} onMouseLeave={() => setHoveringIndex(-1)} key={index} onClick={() => {
                if (status !== 'requesting')
                {
                    setSelectedRecommended(isRecommended);
                    setSelectedIndex(index);
                    play.apply(this, progressionDropItem !== null ? fillProgression(progression) : utilizeProgession(progression));
                }
            }}>
                <DenseTableCell align="left" style={{ minWidth: '150px', backgroundColor: backgroundColor }}>{getProgressionJSX(progression, key, true, 12, '50px')}</DenseTableCell>
            </TableRow>
        );
    }

    function play(clipsToPlay, barsToPlay, bpmToPlay)
    {
        if (wavesurfer.isPlaying())
            wavesurfer.stop();
        const client = applyCaseMiddleware(axios.create());
        const data = { packId: packId, id: sessionId, bars: barsToPlay, key:key, mode:mode, bpm:bpmToPlay, clips: clipsToPlay};
        setStatus('requesting');
        client.post('/session/' + (sessionId === -1 ? 'add' : 'modify'), data, {timeout : 3500}).then(resp => {
            if (sessionId === -1)
                setSessionId(resp.data.data.id);
            wavesurfer.unAll();
            wavesurfer.load(resp.data.data.tempUrl);
            wavesurfer.on("ready", () => {
                wavesurfer.play();
                setStatus('playing');
            })
            wavesurfer.on("pause", () => {
                setStatus('editing');
            })
            wavesurfer.on("finish", () => {
                setStatus('editing');
            })
        }).catch(err => {
            showWarning('Network error. Please try again later')
            setStatus('editing');
        });
    }

    function exit()
    {
        setShowProgression(false);
        setSelectedIndex(-1);
        setHoveringIndex(-1);
        setStatus('editing');
        wavesurfer.stop();
    }

    function randomProgression(isRecommended)
    {
        const progressions = isRecommended ? filteredPresetsProgressions : filteredMyProgressions;
        if (progressions.length === 0)
            return;
        const index = Math.floor(Math.random() * progressions.length);
        const progression = progressions[index];
        play.apply(this, progressionDropItem !== null ? fillProgression(progression) : utilizeProgession(progression));
        const instance = (isRecommended ? presetsScrollBarRef : myScrollBarRef).current.osInstance();
        instance.scroll({y : index * ITEM_HEIGHT - containerHeight / 2});
        setSelectedRecommended(isRecommended);
        setSelectedIndex(index);
    }

    // const Row = ({ index, style }) => (
    //     <div style={style}>Row {index}</div>
    //   );

    return (
    <div className='progression' style={{height: height, display: showProgression ? 'block' : 'none'}}>
        <div className='progression-headers'>
            <div className='progression-header recommended'>
                Recommended Progressions
                <IconButton style={{color: 'white'}} disableRipple onClick={() => randomProgression(true)}>
                    <CasinoOutlinedIcon />
                </IconButton>
            </div>
            <div className='progression-header'>
                Progressions of My Loops
                <IconButton style={{color: 'white'}} disableRipple onClick={() => randomProgression(false)}>
                    <CasinoOutlinedIcon />
                </IconButton>
            </div>
        </div>
        <div className='progression-lists' style={{height: containerHeight}}>
            {/* {fadeProgression && <List height={listHeight} itemCount={filteredPresetsProgressions.length} itemSize={36} width={630}>
                {({ index, style }) => (
                    ProgressionRow(filteredPresetsProgressions[index], index, true, style)
                )}
            </List>}
            <List height={listHeight} itemCount={filteredMyProgressions.length} itemSize={36} width={630}>
                {({ index, style }) => (
                    ProgressionRow(filteredMyProgressions[index], index, false, style)
                )}
            </List> */}
            {
                loadingProgression ? <CircularProgress /> :
                <>
                    <div className='progression-list' style={{height: listHeight}}>
                        <OverlayScrollbarsComponent options={{ className: 'os-theme-light', scrollbars: { autoHide: 'scroll' } }} ref={presetsScrollBarRef}>
                            <TableContainer component={Paper} className={classes.container} style={{height: listHeight}}>
                                <Table classes={{ root: classes.table }} size="small" aria-label="recommended progressions">
                                    <TableBody classes={{ root: classes.body}}>
                                        {filteredPresetsProgressions.map((progression, index) => ProgressionRow(progression, index, true))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </OverlayScrollbarsComponent>
                    </div>
                    <div className='progression-list' style={{height: listHeight}}>
                        <OverlayScrollbarsComponent options={{ className: 'os-theme-light', scrollbars: { autoHide: 'scroll' } }} ref={myScrollBarRef}>
                            <TableContainer component={Paper} className={classes.container} style={{height: listHeight}}>
                                <Table classes={{ root: classes.table }} size="small" aria-label="my progressions">
                                    <TableBody classes={{ root: classes.body}}>
                                        {filteredMyProgressions.map((progression, index) => ProgressionRow(progression, index, false))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </OverlayScrollbarsComponent>
                    </div>
                </>
            }
        </div>
        <div className='progression-footer' onClick={() => 
            { 
                setSelectedIndex(-1);
                if (status === 'playing')
                {
                    setStatus('editing');
                    wavesurfer.stop();
                }
            }}>
            <div className='progression-footer-left'>
                <StyledTypography style={{marginRight: '20px', whiteSpace: 'nowrap'}}>{(selectedIndex !== -1 ? 'Selected' : 'Current') + ' Progression'}</StyledTypography>
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                {getProgressionJSX(selectedIndex !== -1 ? (selectedRecommended ? filteredPresetsProgressions[selectedIndex] : filteredMyProgressions[selectedIndex]) : currentProgression, key, false)}
                </div>
                {progressionDropItem !== null && (selectedIndex !== - 1 || canFillCurrent) && 
                <>
                    <ArrowRightAltIcon style={{color: '#5A5A5A', marginRight: 6}}/>
                    {progressionDropItem.beats === 0 ? <GrooveOneShotIcon /> : <GrooveLoopIcon />}
                </>}
                {(progressionDropItem === null || selectedIndex !== - 1 || canFillCurrent) &&
                <IconButton disableRipple disabled={status === 'requesting'} style={{color: status === 'playing' ? '#FF6500' : '#5A5A5A', marginBottom: 2, marginLeft: progressionDropItem !== null ? 12 : 0}} onClick={(e) => {e.stopPropagation(); status === 'playing' ? wavesurfer.stop() : play(currentClips, currentBars, currentBpm)}}>
                    {status === 'requesting' ? <CircularProgress style={{ width: '24px', height: '24px'}}/> : <HeadphonesIcon />}
                </IconButton>}
            </div>
            
            <div className='progression-footer-right'>
                <Button variant="outlined" style={{textTransform: 'none', width: '120px', marginRight: '30px'}} onClick={() => exit()}>Cancel</Button>
                {progressionDropItem !== null ? 
                <StyledTooltip open={selectedIndex === -1 && !canFillCurrent && overFill} placement='top' arrow title='Current progression does not fit the groove'>
                    <div onMouseEnter={() => setOverFill(true)} onMouseLeave={() => setOverFill(false)}>
                        <Button variant="contained" disabled={selectedIndex === -1 && !canFillCurrent} style={{textTransform: 'none', minWidth: '120px'}} onClick={() => {
                            dispatch(updateClips(currentClips));
                            dispatch(setBars(currentBars));
                            dispatch(setBpm(currentBpm));
                            exit();
                        }}>{'Apply ' + (selectedIndex !== -1 ? 'Selected' : 'Current')}
                        </Button>
                    </div>
                </StyledTooltip>
                : <Button variant="contained" disabled={selectedIndex === -1} style={{textTransform: 'none', minWidth: '120px'}} onClick={() => {dispatch(updateClips(currentClips)); exit()}}>Use Selected</Button>}
            </div>
        </div>
    </div>
    );
}